import React from 'react'
import NotificationCard from '../../shared/components/student/NotificationCard'
import { Grid2 } from '@mui/material'
import SearchInput from '../../shared/components/student/SearchInput'
import { CircularButton } from '../../shared/utils/IconButton'
import { Constants } from '../../shared/constants'
import CustomDivider from '../../shared/utils/CustomDivider'

const Notification = () => {
    return (
        <>
            <Grid2 container>
                <Grid2 children size={4}>
                    <SearchInput />
                </Grid2>
                <Grid2 children size={8} display={"flex"} justifyContent={"end"}>
                    <CircularButton src={Constants.customImages.SettingDark} />
                </Grid2>
            </Grid2>
            <CustomDivider orientation='horizontal' />
            {
                Array.from({ length: 5 }).map((_, index) => (
                    <NotificationCard key={index} />
                ))
            }
        </>
    )
}

export default Notification